import { render, staticRenderFns } from "./oa-sign.vue?vue&type=template&id=dfdf368a&scoped=true&"
import script from "./oa-sign.vue?vue&type=script&lang=js&"
export * from "./oa-sign.vue?vue&type=script&lang=js&"
import style0 from "./oa-sign.vue?vue&type=style&index=0&id=dfdf368a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdf368a",
  null
  
)

export default component.exports